export default __webpack_public_path__ + "media/images/logo-9a1cf168b1aea1975c833fdd6b5c22ec.svg";